import React, { Component } from "react";
import classNames from "classnames";
import { Dropdown, Button as Button } from "@platform/base";
import { RenderMenu } from "../MenuUtil";
import { getSysFieldid, getGlobalStorage } from "@platform/api";
import { getVisible, setVisible } from "../util";

require("./index.less");

// querySelector  不能識別數字開頭 不能識別特殊字符 ·/·
const replaceSpecialStr = function (str) {
    return str.replace(/\/|\\|,/g, "") || str;
};

export default class More extends Component {
    constructor() {
        super();
        this.state = { show: false };
        this.timer = null;
        this.timerIndex = true;
        this.ncc_automated = getGlobalStorage("localStorage", "_ncc_automated_");
    }

    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        let dropdown = document.querySelector('.dropdown-component-list-wrapper-visible' + this.props.clskey);
        if (this.state.show && dropdown) {
            dropdown.style.display = 'none';
            this.setState({ show: false }, () => {
                setTimeout(() => {
                    dropdown.style.display = '';
                    dropdown = null;
                }, 100);
            });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
    }

    onButtonBlur = e => {
        let focusEle = window.event?.relatedTarget;
        this.timeoutId && clearTimeout(this.timeoutId);
        // console.log('onButtonBlur', window.event.relatedTarget);
        this.timeoutId = setTimeout(() => {
            !focusEle && this.state.show && this.onVisibleChange(false);
            focusEle = null;
        }, 300);
    }

    onClick = info => {
        // 在Popover的content中的Menu中调用该事件 由于call绑定了this，Menu和MenuItem中的this都指向More组件
        let key = info.key;
        let title = info.item.props.children;
        this.props.onClick({ key, title });
        this.setState({ show: false });
    };

    onVisibleChange = show => {
        let { onVisibleChange } = this.props;
        let activeItem = document.querySelector('.moreButton-component .button-app-dropdown-menu-wrapper li.wui-menu-item-active');
        
        this.setState({ show }, ()=>{
            if(activeItem){
                //解决 BUG NCC-385735 无法加key解决，会导致上传按钮不走onChange
                activeItem?.classList?.remove("wui-menu-item-active");
            }
        });
        onVisibleChange && onVisibleChange(show);
    };

    render() {
        const {
            list,
            title,
            btncolor,
            disabled,
            json,
            tabindex = 0,
            clskey,
            area,
            //popContainer,
            getPopContainer,
            groupDirection,
            _this,
            getUuid,
        } = this.props;
        // console.log("groupDirection", groupdirection);
        const { show } = this.state;
        let length = list.length;
        for (let items of list) {
            let len = items["children"].length;
            if (len > 1) {
                if (
                    items.hasOwnProperty("visible") &&
                    getVisible.call(_this, items) === false
                ) {
                    length -= 1;
                } else {
                    for (let item of items["children"]) {
                        // 添加一个topParentCode 解决找不到上传class的问题 bbqin
                        item.topParentCode =
                            items.parentCode || item.parentCode;
                        // console.log(item.hasOwnProperty('visible'), item)
                        if (
                            item.hasOwnProperty("visible") &&
                            getVisible.call(_this, item) === false
                        ) {
                            len -= 1;
                        } else {
                            // len = len;
                        }
                        // console.log(len, '-len')
                    }
                    if (len === 0) {
                        // items.visible = false;
                        setVisible.call(_this, items, false);
                        length -= 1;
                    }
                }
            }
        }
        return (
            <div className="mores-wrapper">
                <div
                    className="mores-in-wrapper"
                    onMouseEnter={() => {
                        this.timerIndex = false;
                        clearTimeout(this.timer);
                    }}
                    fieldid={getSysFieldid(`${clskey}_btn`)}
                    btn-code={clskey}
                >
                    <Dropdown
                        trigger={this.ncc_automated === "1" ? ['click'] : ['click', "hover"]}
                        // trigger={['click']}
                        // overlay={renderMenu.call(this, list, undefined, tabindex)}
                        overlay={
                            <div
                                fieldid={getSysFieldid(`${clskey}_btn_list`)}
                                //key={getUuid()}
                                className={classNames("mores-list-wrapper", {
                                    "mores-list-hide-wrapper": !show,
                                    "mores-list-wrapper-vertical":
                                        groupDirection === "vertical",
                                })}
                                // onMouseLeave={() => {
                                //     this.setState({show: false})
                                // }}
                                style={{
                                    // width: `${length * 140 + 30}px`,
                                    maxWidth: "1024px",
                                    whiteSpace: "nowrap",
                                }}
                                btn-code={clskey}
                            >
                                {/* {renderMenu.call(this, list, true, tabindex)} */}
                                <RenderMenu
                                    data={list}
                                    specialDisabled={true}
                                    tabindex={tabindex}
                                    onClick={this.onClick}
                                    visible={show}
                                    _this={_this}
                                    // className={groupDirection === 'horizontal' ? 'menu-item-group' : ""}
                                    className={"menu-item-group"}
                                />
                            </div>
                        }
                        // placement="bottomRight"
                        animation="slide-up"
                        onVisibleChange={this.onVisibleChange}
                        visible={this.state.show}
                        overlayClassName={classNames(
                            "dropdown-component-list-wrapper",
                            { ['dropdown-component-list-wrapper-visible' + clskey]: this.state.show },
                            this.props.className,
                        )}
                        getPopupContainer={getPopContainer}
                    >
                        <span className="dropdown-wrapper-btn">
                            <Button
                                disabled={disabled}
                                className={classNames(
                                    replaceSpecialStr(
                                        ` nc-${area}-${clskey}-icon `,
                                    ),
                                    "moreButton-component",
                                    {
                                        "button-primary":
                                            btncolor == "button_main",
                                    },
                                )}
                                // onClick={() => !disabled && this.setState({ show: !show })}
                                tabindex={tabindex}
                                fieldid={clskey}
                                btn-code={clskey}
                                onBlur={this.onButtonBlur}
                            >
                                {title || json["page-button-0004"]}
                                <i
                                    className={classNames(
                                        "arrow icon iconfont",
                                        {
                                            "button-primary":
                                                btncolor == "button_main",
                                            "icon-hangcaozuoxiangshang1": show,
                                            "icon-hangcaozuoxiala1": !show,
                                        },
                                    )}
                                />
                            </Button>
                            {/* <div className='more-beijing-wrapper' /> */}
                            {/* <span
                                className={classNames({
                                    'mores-sanjiao': show,
                                    'mores-sanjiao mores-sanjiao-hide': !show,
                                })}
                            /> */}
                        </span>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

More.defaultProps = {
    list: [],
    popPlacement: "bottomRight", // 弹窗窗口的位置
};
